import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const CheckCircle = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M11.5644 6.49388L10.4356 5.50612L7.40814 8.96604L5.46852 7.41435L4.53148 8.58565L7.59186 11.034L11.5644 6.49388Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM13.5 8C13.5 11.0376 11.0376 13.5 8 13.5C4.96243 13.5 2.5 11.0376 2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C11.0376 2.5 13.5 4.96243 13.5 8Z"
      fill="currentColor"
    />
  </Icon>
));

export default CheckCircle;
